<template>
    <blog-content-section
        :content="attributes.content"
        :published-at="attributes.__page.published_at"
    />
</template>

<script>
    import BlogContentSection from '../../../organisms/BlogContentSection/BlogContentSection';

    export default {
        name: 'blog-post-section-module',

        components: { BlogContentSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
